import Wrapper from '../assets/wrappers/Nav'
import React from 'react'
import { useLocation } from 'react-router-dom'
import { useRef, useEffect } from 'react'
import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { FaAlignJustify } from 'react-icons/fa'
import { FaCaretDown } from 'react-icons/fa'

// custom hook
function useDetectClickOutside(ref, setShow) {
  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        // close popup
        setShow(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, setShow])
}

export const Nav = () => {
  // let location = useLocation()
  const [showNav, setShow] = useState(false)
  const [dropDownActive, setDropDown] = useState(false)
  // const [showDropDown, setShowDropDown] = useState(false)
  const [isHovering, setIsHovering] = useState(false)
  const wrapperRef = useRef(null)

  const location = useLocation()
  useEffect(() => {
    // This code will run whenever the location object changes
    if (
      location.pathname === '/contact' ||
      location.pathname === '/hall-of-fame'
    ) {
      setDropDown(true)
    } else {
      setDropDown(false)
    }
    // Example: Send an analytics event
    // trackPageview(location.pathname);
  }, [location])

  // close on click outside
  useDetectClickOutside(wrapperRef, setShow)
  const handleClick = () => {
    showNav ? setShow(false) : setShow(true)
  }
  const handleItemClick = () => {
    setShow(false)
    //
    // ?setShowDropDown(true)
    // ! new fix to close dropdown after clicking items
    setIsHovering(false)
  }
  const handleMouseOver = () => {
    setIsHovering(true)
  }
  const handleMouseOut = () => {
    setIsHovering(false)
  }
  // const handleDropItemClick = () => {}

  return (
    // <nav className='navbar' id='navbar'>
    <Wrapper ref={wrapperRef}>
      <div className='nav-center topnav'>
        <div className='nav-header'>
          <button
            onClick={handleClick}
            className={`nav-btn ${showNav ? 'active-nav-btn' : ''}`}
            id='nav-btn'
          >
            <FaAlignJustify />
          </button>
        </div>
        <ul className={`nav-items ${showNav ? 'show-items' : ''}`}>
          <li>
            <NavLink to='/' className='nav-link' onClick={handleItemClick}>
              home
            </NavLink>
          </li>
          <li>
            <NavLink
              to='/biography'
              className='nav-link'
              onClick={handleItemClick}
            >
              biography
            </NavLink>
          </li>
          <li>
            <NavLink
              to='/lessons'
              className='nav-link'
              onClick={handleItemClick}
            >
              lessons
            </NavLink>
          </li>
          <li>
            <NavLink
              to='/awards'
              className='nav-link'
              onClick={handleItemClick}
            >
              awards
            </NavLink>
          </li>
          <li>
            <NavLink
              to='/photos'
              className='nav-link'
              onClick={handleItemClick}
            >
              photos
            </NavLink>
          </li>
          <li>
            <NavLink
              to='/videos'
              className='nav-link'
              onClick={handleItemClick}
            >
              videos
            </NavLink>
          </li>
          {/* DROP DOWN */}
          <li>
            <div
              className='dropdown'
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
            >
              {/* <button class='dropbtn nav-link'> */}
              <button
                className={`dropbtn nav-link ${
                  dropDownActive ? 'dropbtn-active' : ''
                }`}
              >
                about
                <FaCaretDown style={{ paddingLeft: '0.55rem' }} />
                {/* <FaCaretDown /> */}
                {/* <i class='fa fa-caret-down'></i> */}
              </button>
              {/* <div className='dropdown-content'> */}
              <div
                className={`dropdown-content  ${
                  isHovering ? 'is-hovering' : ''
                }`}
                // style={{ display: `${showDropDown ? 'none' : 'block'}` }}
              >
                <NavLink
                  to='/contact'
                  className={`drop-down-link ${
                    location.pathname === '/contact' ? 'drop-down-active' : ''
                  }`}
                  //   {`dropbtn nav-link ${
                  //   dropDownActive ? 'dropbtn-active' : ''
                  // }`}
                  onClick={handleItemClick}
                >
                  contact
                </NavLink>
                <NavLink
                  to='/hall-of-fame'
                  className={`drop-down-link ${
                    location.pathname === '/hall-of-fame'
                      ? 'drop-down-active'
                      : ''
                  }`}
                  // className='nav-link'
                  onClick={handleItemClick}
                >
                  hall of fame
                </NavLink>
                {/* <a href='#'>Link 1</a>
                <a href='#'>Link 2</a>
                <a href='#'>Link 3</a> */}
              </div>
            </div>
          </li>
          {/* <li>
            <NavLink
              to='/contact'
              className='nav-link'
              onClick={handleItemClick}
            >
              contact
            </NavLink>
          </li> */}
        </ul>
      </div>
    </Wrapper>
    // </nav>
  )
}
